import React, { useEffect, useState, useContext } from 'react';
import { withRouter} from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import axiosConfig from '../../../../utils/axiosConfig';
import Alert from '@material-ui/lab/Alert';
import { Formik, Form, Field } from 'formik';
import { fieldToTextField, TextField, TextFieldProps, Select, Switch } from 'formik-material-ui';
import {
    Box, Button, Dialog, DialogActions,
    DialogContent, DialogContentText, DialogTitle,
    FormHelperText, Grid, List, ListItem, ListItemText,
    MenuItem, Slide, Typography
} from '@material-ui/core';

import SnackbarPopup from '../../../../components/Shared/SnackbarPopup/SnackbarPopup';
import { StateContext, DispatchContext } from '../../../../context/Provider';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const UserModalForm = (props) => {

    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);
    const { authState, globalState, facultyState } = appState;
    const { globalDispatch, facultyDispatch } = appDispatch;

    // const {open, handleClose, selectedSchool} = props;
    const [school, setSchool] = useState({
        school_name: '',
        email: '',
        school_address: '',
        contact_no: '',
        subdomain: ''
    });

    async function createSchool(values, resetForm) {
        const res = await axiosConfig.post(`/schools`, {
            name: values.school_name,
            email: values.email,
            address: values.school_address,
            contact_no: values.contact_no,
            subdomain: values.subdomain
        });

        if (res.data.status_code == 'ok') {
            globalDispatch({type: 'setSnackbarMsg', value: 'School created successfully.'});
            globalDispatch({type: 'setIsOpenSnackbar', value: true});

            props.fetchSchools();
            props.handleClose();

        } else {
            console.log(res);
        }
        
        globalDispatch({type: 'setIsLoading', value: false});
        setTimeout(() => {
            globalDispatch({type: 'setIsOpenSnackbar', value: false});
        }, 1200);
    }

    async function updateSchool(values, resetForm) {
        const res = await axiosConfig.post(`/schools/${props.selectedSchool.id}`, {
            _method: 'PATCH',
            school_id: props.selectedSchool.id,
            name: values.school_name,
            email: values.email,
            address: values.school_address,
            contact_no: values.contact_no,
            subdomain: values.subdomain
        });

        if (res.data.status_code == 'ok') {
            globalDispatch({type: 'setSnackbarMsg', value: 'School updated successfully.'});
            globalDispatch({type: 'setIsOpenSnackbar', value: true});

            props.fetchSchools();
            props.handleClose();
        } else {
            console.log(res);
        }

        globalDispatch({type: 'setIsLoading', value: false});
        setTimeout(() => {
            globalDispatch({type: 'setIsOpenSnackbar', value: false});
        }, 1200);
    }

    useEffect(() => {
        if (props.selectedSchool) {
            setSchool({
                school_name: props.selectedSchool.school_name,
                email: props.selectedSchool.email,
                school_address: props.selectedSchool.school_address,
                contact_no: props.selectedSchool.contact_no,
                subdomain: props.selectedSchool.subdomain
            });
        }

    }, [props.selectedSchool]);

    return (
        <Dialog 
            open={props.open} 
            onClose={props.handleClose} 
            aria-labelledby="form-dialog-title"
            fullWidth={true} 
            maxWidth={'md'}
            TransitionComponent={Transition}
            disableBackdropClick 
        >
            <Formik
                initialValues={school}
                validate={(values) => {
                    const errors = {};

                    if (!values.school_name) {
                        errors.school_name = 'This field is required';
                    }

                    if (!values.email) {
                        errors.email = 'This field is required';
                    }

                    if (!values.school_address) {
                        errors.school_address = 'This field is required';
                    }

                    if (!values.contact_no) {
                        errors.contact_no = 'This field is required';
                    }

                    if (!values.subdomain) {
                        errors.subdomain = 'This field is required';
                    }

                    return errors;
                }}
                onSubmit={(values, {setSubmitting, resetForm}) => {

                    setSubmitting(false);
                    globalDispatch({type: 'setIsLoading', value: true});

                    if (props.selectedSchool === null) {
                        createSchool(values, resetForm);
                    } else {
                        updateSchool(values, resetForm);
                    }
                }}
            >
                {({submitForm, isSubmitting, touched, errors}) => (
                    <Form>
                        <DialogTitle id="form-dialog-title">
                            School Information
                        </DialogTitle>
                        <DialogContent>

                            <DialogContentText>
                                Kindly enter the complete details of the school below.
                            </DialogContentText>

                            <Box pb={2} />

                            <Grid container alignItems="flex-start" spacing={2}>

                                <Grid item xs={12}>
                                    <Field
                                        component={TextField}
                                        label="School Name*"
                                        name="school_name"
                                        fullWidth
                                        variant="outlined"
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Field
                                        component={TextField}
                                        label="Email Address*"
                                        name="email"
                                        fullWidth
                                        variant="outlined"
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Field
                                        component={TextField}
                                        label="School Address*"
                                        name="school_address"
                                        multiline
                                        rows={4}
                                        fullWidth
                                        variant="outlined"
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Field
                                        component={TextField}
                                        label="Contact No.*"
                                        name="contact_no"
                                        fullWidth
                                        variant="outlined"
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Field
                                        component={TextField}
                                        label="Subdomain*"
                                        name="subdomain"
                                        fullWidth
                                        variant="outlined"
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button 
                                onClick={props.handleClose} 
                                disabled={isSubmitting} 
                                color="secondary"
                            >
                                Cancel
                            </Button>
                            <Button
                                disabled={isSubmitting} 
                                onClick={submitForm} color="primary"
                            >
                                Submit
                            </Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );

}

export default UserModalForm;
